import { Link, useLocation } from 'react-router-dom';
import type { Category } from '@/mocks/categories';

interface CategoryTabsProps {
  categories: Category[];
}

export default function CategoryTabs({ categories }: CategoryTabsProps) {
  const location = useLocation();
  const currentSlug = location.pathname.split('/category/')[1] || '';

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-200 cursor-pointer flex items-center gap-1.5 ${
            currentSlug === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-700 hover:bg-background-200'
          }`}
        >
          <i className={`${cat.icon} w-4 h-4 flex items-center justify-center`}></i>
          {cat.name}
        </Link>
      ))}
    </div>
  );
}